
<div class="d-flex flex-column h-100 text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Manage GPU Instances</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>
  <div class="modal-body">
    <div class="d-flex justify-content-center align-items-center">
      Create 
        <select name="" id="" [formControl]="selectedFrame" class="mx-2 form-select form-select-sm" style="width:auto">
          <option value="" *ngFor="let frame of data.frameBufferInGB.split(',')" [value]="frame">{{frame}}</option>
        </select> instances of GPU <button class="ms-2 btn btn-sm btn-primary" (click)="createInstances()">Create</button>
    </div>
    <hr>
    <table class="table mb-0" *ngIf="gpuInstanceList?.length; else emptyMessage" >
      <thead class="thead-dark newclass">
        <th>#</th>
        <th>vGPU Type</th>
        <th>Name</th>
        <th>Memory Size</th>
        <th>Attached Node</th>
      </thead>
      <tbody>
        <tr *ngFor="let gpu of gpuInstanceList, let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ gpu.pcIeId }}</td>
          <td>{{ gpu.instanceName }}</td>
          <td>{{ gpu.memorySize }}</td>
          <td>{{ gpu.vmName  || 'NA'}}</td>
        </tr>
      </tbody>
    </table>
    <ng-template #emptyMessage><p class="emptyMessage">{{ noInstanceMessage }}</p></ng-template>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="onClose()" class="btn btn-outline-secondary me-1">Close</button>
    <!-- <button type="button" (click)="onSubmit()" class="btn btn-primary">
      Apply
    </button> -->
  </div>
</div>
